
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { ChatFeedbackInterface, TicketFeedbackInterface } from '@/services/QC-V2/feedback/interfaces';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';

@Component({
  mixins: [
    Themeable,
  ],
})
export default class FeedbackDetails extends Vue {
  @Prop() private feedback!: ChatFeedbackInterface | TicketFeedbackInterface;

  @Prop() private profilesMap!: ProfileMapInterface;

  private loading: boolean = false;

  private feedbackStatusMap: string[] = [
    'SENT',
    'SEEN',
    'REPLIED',
    'ANSWERED',
    'CLOSED',
  ];
}
